import { OtherSubtype, ShopCategory, ShopCategoryConfig } from './types'

export const OTHER_SUBTYPES: OtherSubtype[] = [
  'general',
  'dc_optimizer',
  'isolator',
  'meter',
  'cable',
  'battery_accessory',
  'battery_inverter',
  'inverter_accessory',
  'mounting_rail',
  'mounting_roof_anchor',
  'mounting_clamp',
  'mounting_flashing',
  'mounting_roof_fixing',
  'mounting_other',
  'ev_charger',
  'subscription',
  'heat_pump',
  'vehicle',
]

export const DEFAULT_SHOP_CATEGORIES: ShopCategory[] = [
  {
    id: 'modules',
    name: 'Panels',
    componentType: 'module',
    searchKey: 'modules',
    order: 1,
    enabled: true,
    imageUrl: null,
  },
  {
    id: 'inverters',
    name: 'Inverters',
    componentType: 'inverter',
    searchKey: 'inverters',
    order: 2,
    enabled: true,
    imageUrl: null,
  },
  {
    id: 'batteries',
    name: 'Batteries',
    componentType: 'battery',
    searchKey: 'batteries',
    order: 3,
    enabled: true,
    imageUrl: null,
  },
  {
    id: 'mounting_bos',
    name: 'Mounting + BOS',
    componentType: 'other',
    subtypes: ['*'],
    searchKey: 'others',
    order: 4,
    enabled: true,
    imageUrl: null,
  },
]

export const DEFAULT_SHOP_CATEGORY_CONFIG: ShopCategoryConfig = {
  categories: DEFAULT_SHOP_CATEGORIES,
}

export const SHOP_CATEGORY_CONTROL_KEY = 'shop_category_control'

// Hard cap on the number of categories rendered on a single Shop surface
// (homepage bento grid, sidebar submenu). The config may declare more — extras
// still flow through to filters and routing — but list-style surfaces are
// bounded here to keep the layout aligned with the Figma design.
export const MAX_DISPLAYED_CATEGORIES = 8
